










import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {DashboardStore} from "@/modules/dashboard/store";
import CardStatistic from "@/modules/dashboard/components/cardstatistic/index.vue";

@Component({
    name: "StatisticLading",
    components: {CardStatistic}
})
export default class extends mixins(CommonMixin) {
    get statistics() {
        return DashboardStore.statisticLading;
    }

    get colMd() {
        return 24 / (this.statistics.length || 1);
    }
}
